import type { Document as RichTextDocument } from '@contentful/rich-text-types'
import { BLOCKS } from '@contentful/rich-text-types'
import type { FC } from 'react'

import type { Options as RichTextRenderOptions } from '@contentful/rich-text-react-renderer'

import styled from '@emotion/styled'

import { Button } from '@segment/matcha/components/Button/Button'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import RichText, { ColoredTypography } from '@segment/matcha/recipes/RichText'

import useScrollToAnchor from '@segment/utils/useScrollToAnchor/useScrollToAnchor'

import { CONTENT_DOWNLOAD_HERO_ID } from '../Hero/Hero'

const options: RichTextRenderOptions = {
  renderNode: {
    [BLOCKS.PARAGRAPH](node, children) {
      return (
        <StyledColoredTypography variant="pLarge" tag="p">
          {children}
        </StyledColoredTypography>
      )
    },
  },
}

interface SectionProps {
  heading?: string
  description: RichTextDocument
  buttonText?: string
}

const ContentSection: FC<SectionProps> = ({ heading, description, buttonText }) => {
  const scroll = useScrollToAnchor(CONTENT_DOWNLOAD_HERO_ID)
  return (
    <SectionBase variant="noCopy" reverse={true}>
      <StyledSectionContents>
        <CopyTextBase centered={false}>
          <CopyText.Heading variant="h2" tag="h2">
            {heading}
          </CopyText.Heading>
        </CopyTextBase>
        <RichText data={description} options={options} />
        <ButtonWrapper>
          <Button color="primary" variant="filled" size="large" onClick={() => scroll()}>
            {buttonText}
          </Button>
        </ButtonWrapper>
      </StyledSectionContents>
    </SectionBase>
  )
}

const StyledColoredTypography = styled(ColoredTypography)`
  white-space: pre-line;
`

const StyledSectionContents = styled(Section.Contents)`
  max-width: 844px;
  margin: 0 auto;
`

const ButtonWrapper = styled.div`
  margin-top: 56px;
  width: 100%;
  text-align: center;
`

export default ContentSection
